import plural from 'helpers/plural';

angular.module('gym.components').directive('messageStatusNotice', function() {
  return {
    restrict: 'E',
    scope: {
      item: '='
    },
    template: require('templates/components/contacts/comms/message_status_notice.html.slim'),
    controller: ["$scope", "ReactModal", function($scope, ReactModal) {
      var badges, ref, ref1;
      badges = $scope.item.data.badges;
      $scope.openedBadge = badges != null ? badges.find(function(i) {
        return i.type === 'opened';
      }) : void 0;
      $scope.spamBadge = badges != null ? badges.find(function(i) {
        return i.type === 'flagged_as_spam';
      }) : void 0;
      if ($scope.openedBadge) {
        $scope.timestamp = moment.utc($scope.openedBadge.timestamp).local().format('YYYY-MM-DD HH:mm');
        $scope.formattedTimestamp = moment.utc($scope.openedBadge.timestamp).local().format('DD-MMM-YYYY');
      }
      $scope.openedTooltip = `<div class="long-content-tooltip-inner">
  Email has been opened ${plural('time', (ref = $scope.item.data) != null ? ref.open_count : void 0, true)}
</div>`;
      $scope.clickedTooltip = `<div class="long-content-tooltip-inner">
  Link(s) in this email have been clicked ${plural('time', (ref1 = $scope.item.data) != null ? ref1.click_count : void 0, true)}
</div>`;
      return $scope.displayActivitySummary = function() {
        return ReactModal.open({
          component: 'BulkMessageActivityDrawer',
          drawer: true,
          props: {
            logEntry: $scope.item
          }
        });
      };
    }]
  };
});
